import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useBookImages = (bookId: string | undefined) => {
  return useQuery({
    queryKey: ["book-images", bookId],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("book_images")
        .select("image_url")
        .eq("book_id", bookId!)
        .order("sort_order", { ascending: true });
      if (error) throw error;
      return (data ?? []).map((d: any) => d.image_url as string);
    },
    enabled: !!bookId,
  });
};
